//Concatenates lists from a specific point in a defined json structure
export function orderBy(order, arr){
  var newArr = arr.sort((s1, s2) => {
    return s1[order] > s2[order] ? 1 : -1;
  })
  return newArr;
}
